import { endpoint, dateToServer } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/resources';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'ogden-tables';

/**
 * Multipliers Mini Calculator Endpoints:
 */
export default {

    /**
     * Ogden Table Info.
     *
     * @return {Promise}
     */
    tableInfo() {
        return endpoint(`${PARENT}/${RESOURCE}`, 'load');
    },

    /**
     * Obtain a specific ogden table
     * @param ogdenTable
     * @returns {*}
     */
    obtainValues(ogdenTable) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'obtain-values', {ogdenTable});
    },

    /**
     *
     * @param discount
     * @param gender
     * @returns {*}
     */
    atAGlance(discount, gender) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'at-a-glance', {discount, gender});
    }
};



// WEBPACK FOOTER //
// ./src/services/api/resources/ogden-tables.js